import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Tabs } from '../../components/ui/Tabs';
import { Badge } from '../../components/ui/Badge';
import { Settings, Users, Shield, Bell, Database, Mail } from 'lucide-react';
export function SystemConfig() {
  const [activeTab, setActiveTab] = useState('general');
  const renderGeneral = () => <div className="space-y-6" data-id="element-778">
      <Card title="Informasi Sistem" data-id="element-779">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-780">
          <Input label="Nama Sistem" defaultValue="BULOG Enterprise System" data-id="element-781" />
          <Input label="Versi Aplikasi" defaultValue="v2.5.0" disabled data-id="element-782" />
          <Input label="Environment" defaultValue="Production" disabled data-id="element-783" />
          <Select label="Timezone" options={[{
          value: 'wib',
          label: 'WIB (GMT+7)'
        }, {
          value: 'wita',
          label: 'WITA (GMT+8)'
        }, {
          value: 'wit',
          label: 'WIT (GMT+9)'
        }]} data-id="element-784" />
        </div>
      </Card>

      <Card title="Pengaturan Regional" data-id="element-785">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-786">
          <Select label="Bahasa Default" options={[{
          value: 'id',
          label: 'Bahasa Indonesia'
        }, {
          value: 'en',
          label: 'English'
        }]} data-id="element-787" />
          <Select label="Format Tanggal" options={[{
          value: 'dd/mm/yyyy',
          label: 'DD/MM/YYYY'
        }, {
          value: 'mm/dd/yyyy',
          label: 'MM/DD/YYYY'
        }, {
          value: 'yyyy-mm-dd',
          label: 'YYYY-MM-DD'
        }]} data-id="element-788" />
          <Select label="Format Angka" options={[{
          value: 'id',
          label: '1.234.567,89'
        }, {
          value: 'en',
          label: '1,234,567.89'
        }]} data-id="element-789" />
          <Input label="Mata Uang" defaultValue="IDR - Rupiah" disabled data-id="element-790" />
        </div>
      </Card>
    </div>;
  const renderUsers = () => <div className="space-y-6" data-id="element-791">
      <Card title="Manajemen User" action={<Button size="sm" data-id="element-793">Tambah User</Button>} data-id="element-792">
        <div className="space-y-3" data-id="element-794">
          {[{
          name: 'Admin Pusat',
          role: 'Super Admin',
          status: 'Active',
          email: 'admin@bulog.co.id'
        }, {
          name: 'Admin Gudang JKT',
          role: 'Warehouse Manager',
          status: 'Active',
          email: 'gudang.jkt@bulog.co.id'
        }, {
          name: 'Admin Program',
          role: 'Program Manager',
          status: 'Active',
          email: 'program@bulog.co.id'
        }].map((user, i) => <div key={i} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-795">
              <div className="flex items-center gap-3" data-id="element-796">
                <div className="w-10 h-10 rounded-full bg-bulog-blue text-white flex items-center justify-center font-bold" data-id="element-797">
                  {user.name.charAt(0)}
                </div>
                <div data-id="element-798">
                  <p className="font-semibold text-gray-900" data-id="element-799">{user.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-800">{user.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-801">
                <Badge variant="info" data-id="element-802">{user.role}</Badge>
                <Badge variant="success" data-id="element-803">{user.status}</Badge>
                <Button size="sm" variant="outline" data-id="element-804">
                  Edit
                </Button>
              </div>
            </div>)}
        </div>
      </Card>

      <Card title="Role & Permissions" data-id="element-805">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-806">
          {['Super Admin', 'Warehouse Manager', 'Program Manager'].map(role => <div key={role} className="p-4 border border-gray-200 rounded-lg" data-id="element-807">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-808">{role}</h4>
                <p className="text-sm text-gray-500 mb-3" data-id="element-809">
                  Full access to all modules
                </p>
                <Button size="sm" variant="outline" className="w-full" data-id="element-810">
                  Manage Permissions
                </Button>
              </div>)}
        </div>
      </Card>
    </div>;
  const renderSecurity = () => <div className="space-y-6" data-id="element-811">
      <Card title="Autentikasi & Keamanan" data-id="element-812">
        <div className="space-y-4" data-id="element-813">
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-814">
            <div data-id="element-815">
              <p className="font-semibold text-gray-900" data-id="element-816">
                Two-Factor Authentication (2FA)
              </p>
              <p className="text-sm text-gray-500" data-id="element-817">
                Wajibkan 2FA untuk semua user
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-818">
              <input type="checkbox" defaultChecked className="sr-only peer" data-id="element-819" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-bulog-blue/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-bulog-blue" data-id="element-820"></div>
            </label>
          </div>

          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-821">
            <div data-id="element-822">
              <p className="font-semibold text-gray-900" data-id="element-823">Session Timeout</p>
              <p className="text-sm text-gray-500" data-id="element-824">
                Auto logout setelah tidak aktif
              </p>
            </div>
            <Select options={[{
            value: '15',
            label: '15 menit'
          }, {
            value: '30',
            label: '30 menit'
          }, {
            value: '60',
            label: '1 jam'
          }]} className="w-32" data-id="element-825" />
          </div>

          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-826">
            <div data-id="element-827">
              <p className="font-semibold text-gray-900" data-id="element-828">Password Policy</p>
              <p className="text-sm text-gray-500" data-id="element-829">
                Minimum 8 karakter, huruf besar, angka
              </p>
            </div>
            <Button size="sm" variant="outline" data-id="element-830">
              Edit Policy
            </Button>
          </div>
        </div>
      </Card>

      <Card title="Audit & Logging" data-id="element-831">
        <div className="space-y-3" data-id="element-832">
          <div className="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded-lg" data-id="element-833">
            <div className="flex items-center gap-2" data-id="element-834">
              <Shield className="text-green-600" size={20} data-id="element-835" />
              <span className="font-medium text-green-900" data-id="element-836">
                Audit Trail: Aktif
              </span>
            </div>
            <Badge variant="success" data-id="element-837">Enabled</Badge>
          </div>
          <div className="flex items-center justify-between p-3 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-838">
            <div className="flex items-center gap-2" data-id="element-839">
              <Database className="text-bulog-blue" size={20} data-id="element-840" />
              <span className="font-medium text-bulog-blue" data-id="element-841">
                Log Retention: 90 hari
              </span>
            </div>
            <Button size="sm" variant="outline" data-id="element-842">
              Configure
            </Button>
          </div>
        </div>
      </Card>
    </div>;
  const renderNotifications = () => <div className="space-y-6" data-id="element-843">
      <Card title="Email Notifications" data-id="element-844">
        <div className="space-y-4" data-id="element-845">
          {[{
          label: 'Exception Alerts',
          desc: 'Notifikasi untuk quality issues dan delays'
        }, {
          label: 'Stock Alerts',
          desc: 'Peringatan stok kritis atau aging'
        }, {
          label: 'Program Updates',
          desc: 'Update status program dan realisasi'
        }, {
          label: 'System Maintenance',
          desc: 'Pemberitahuan maintenance terjadwal'
        }].map((notif, i) => <div key={i} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-846">
              <div data-id="element-847">
                <p className="font-semibold text-gray-900" data-id="element-848">{notif.label}</p>
                <p className="text-sm text-gray-500" data-id="element-849">{notif.desc}</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-850">
                <input type="checkbox" defaultChecked className="sr-only peer" data-id="element-851" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-bulog-blue/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-bulog-blue" data-id="element-852"></div>
              </label>
            </div>)}
        </div>
      </Card>

      <Card title="SMTP Configuration" data-id="element-853">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-854">
          <Input label="SMTP Server" defaultValue="smtp.bulog.co.id" data-id="element-855" />
          <Input label="SMTP Port" defaultValue="587" type="number" data-id="element-856" />
          <Input label="Username" defaultValue="noreply@bulog.co.id" data-id="element-857" />
          <Input label="Password" type="password" defaultValue="••••••••" data-id="element-858" />
        </div>
        <div className="mt-4 flex gap-2" data-id="element-859">
          <Button variant="outline" data-id="element-860">Test Connection</Button>
          <Button data-id="element-861">Save Configuration</Button>
        </div>
      </Card>
    </div>;
  const tabs = [{
    id: 'general',
    label: 'General',
    content: renderGeneral()
  }, {
    id: 'users',
    label: 'Users & Roles',
    content: renderUsers()
  }, {
    id: 'security',
    label: 'Security',
    content: renderSecurity()
  }, {
    id: 'notifications',
    label: 'Notifications',
    content: renderNotifications()
  }];
  return <div className="space-y-6" data-id="element-862">
      <div data-id="element-863">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-864">Konfigurasi Sistem</h1>
        <p className="text-gray-500 mt-1" data-id="element-865">
          Pengaturan aplikasi dan preferensi sistem
        </p>
      </div>

      <Tabs tabs={tabs} data-id="element-866" />
    </div>;
}